import { useSelector } from 'react-redux'

import { selectCurrentRoom } from '@store/actionSlices/appConfig'
import { RootStateTypeExtra } from '@store/types'

import {
  selectShowcaseRoomConfigFromResult,
  useGetShowcaseRoomConfigQuery,
} from '@api/showcase-room'

const useRoomConfigData = () => {
  const projectName = useSelector(
    (state: RootStateTypeExtra) => state.projectIdentity.projectName
  )

  const currentRoom = useSelector(selectCurrentRoom)

  const {
    isLoaded: isLoadedRoomConfigQuery,
    showcaseRoomConfig: roomConfigData,
  } = useGetShowcaseRoomConfigQuery(
    {
      projectName,
      showcaseRoomId: currentRoom,
    },
    {
      selectFromResult: selectShowcaseRoomConfigFromResult,
      skip: !currentRoom,
    }
  )

  return {
    roomConfigData: currentRoom ? roomConfigData : undefined,
    isProcessing: !isLoadedRoomConfigQuery,
  }
}

export default useRoomConfigData
